export default "__VITE_ASSET__94a77dcb__"